import { IRedeemCodeData } from 'types/redemption';
import {
    REMOVE_REDEMPTION_STATUS,
    SET_REDEMPTION_STATUS,
    SET_REDEEM_DATA,
    SET_REDEMPTION_STATUS_FETCHING,
    SET_REDEMPTION_CODE,
    SET_REDEMPTION_PLATFORM_TYPE,
    REDEMPTION_STATUS
} from './redemption.constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { RedemptionActions } from 'widgets/redeem/modules/redemption/redemption.actions';

import { IFieldRenderParams } from 'modules/additional-info-common/fields/fields.types';
import { ITEM_TYPE } from '@sitegen/common/types';

export const initialState: IRedemptionStatus = {
    fetching: null,
    status: null,
    unlockedContent: [],
    redeemData: {
        code: null,
        platform: null
    },
    additionalDetailsDefinition: null,
    codeFirstPlatforms: []
};

export const reducerKey = 'redemption' as const;

export const redemptionReducer = (state = initialState, action: RedemptionActions): IRedemptionStatus => {
    switch (action.type) {
    case SET_REDEMPTION_STATUS_FETCHING:
        return { ...state, fetching: action.payload };
    case SET_REDEMPTION_STATUS:
        return { ...state, ...action.payload, fetching: false };
    case SET_REDEEM_DATA:
        return { ...state, redeemData: action.payload };
    case SET_REDEMPTION_PLATFORM_TYPE:
        return {
            ...state, redeemData: {
                ...state.redeemData,
                platform: action.payload
            }
        };
    case SET_REDEMPTION_CODE:
        return {
            ...state, redeemData: {
                ...state.redeemData,
                code: action.payload
            }
        };
    case REMOVE_REDEMPTION_STATUS:
        return initialState;
    default:
        return state;
    }
};

export default redemptionReducer;

export type RedemptionStatus = {
    status: REDEMPTION_STATUS | null,
    unlockedContent?: IRedeemContent[],
    additionalDetailsDefinition?: IFieldRenderParams[] | null,
    codeFirstPlatforms?: PLATFORM_TYPES[],
    availableActions?: string[]
};

export interface IRedemptionStatus extends RedemptionStatus {
    fetching: boolean | null;
    redeemData: IRedeemCodeData;
}

export interface IRedeemContent {
    redeemActionType: ITEM_TYPE | string;
    itemName: string;
    status: string; // "REDEEMED_AND_DELIVERED" | "REDEEMED_NOT_DELIVERED"
    deliveryDate: string | null;
    redeemActionDetails: {
        key: string | null,
        quantity: number
    };
}
